import React from 'react';

import styled from 'styled-components';

import { AssetContainer } from '~/techstyle-shared/react-assets';
import {
  mobile,
  useBreakpoint,
  Video,
} from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

const DESKTOP_VIDEO_HEIGHT = 634;
const DESKTOP_VIDEO_WIDTH = 1440;
const MOBILE_VIDEO_HEIGHT = 568;
const MOBILE_VIDEO_WIDTH = 376;

const Wrapper = styled.div`
  position: relative;
`;

const Overlay = styled.div`
  width: 420px;
  position: absolute;
  top: 30px;
  left: 0;
  right: 0;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;

  /*
   * Keeps the text from overlapping the app part of the video on tablets or
   * small desktop windows
   */
  @media (max-width: 915px) {
    width: 65%;
  }

  ${mobile`
    width: 81%;
  `}
`;

const Title = styled.div`
  font-weight: bold;
  font-size: 30px;
  line-height: 37px;

  ${mobile`
    margin-bottom: 15px;
  `}
`;

const TextCopy = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
`;

export default function FitAppPagePrograms() {
  const { isMobile } = useBreakpoint();

  return (
    <Wrapper>
      <AssetContainer
        name={
          isMobile
            ? 'fitnessapp_content2_mobile'
            : 'fitnessapp_content2_desktop'
        }
      >
        {({ data }) =>
          data ? (
            <Video
              aspectRatio={
                isMobile
                  ? MOBILE_VIDEO_WIDTH / MOBILE_VIDEO_HEIGHT
                  : DESKTOP_VIDEO_WIDTH / DESKTOP_VIDEO_HEIGHT
              }
              hasControls={false}
              url={data.imageFilename}
            />
          ) : null
        }
      </AssetContainer>
      <Overlay>
        <Title>
          <FormattedMessage
            defaultMessage="Programs for Everyone"
            id="fitness_app.section_3_title"
          />
        </Title>
        <TextCopy>
          <FormattedMessage
            defaultMessage="Our fitness programs are built for real results through a series of classes ranging from 14-30 days - so you can find your perfect routine"
            id="fitness_app.section_3_copy"
          />
        </TextCopy>
      </Overlay>
    </Wrapper>
  );
}
